export const buildWarning = function (message) {
  let gravity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'warning';
  let alreadyWarned = false;
  const cleanMessage = Array.isArray(message) ? message.join('\n') : message;
  return () => {
    if (!alreadyWarned) {
      alreadyWarned = true;
      if (gravity === 'error') {
        console.error(cleanMessage);
      } else {
        console.warn(cleanMessage);
      }
    }
  };
};
export const wrapWithWarningOnCall = (method, message) => {
  if (process.env.NODE_ENV === 'production') {
    return method;
  }
  const warning = buildWarning(message);
  return function () {
    warning();
    return method(...arguments);
  };
};